export default __webpack_public_path__ + "static/media/Message_alt_light.dd710b20.svg";